mutation InvoiceBatchCreate(
  $input: InvoiceBatchCreateInput!
  $batchInputId: UUID!
) {
  invoiceBatchCreate(input: $input) {
    clientMutationId
    insertedEntities {
      id
      rowTimestamp
    }
    query {
      batchTransaction(id: $batchInputId) {
        _batchTransactionCount
        _batchTransactionTotal
      }
    }
  }
}
